var _tspan, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmbientSound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 3.4039314,
    y: 20.956221,
    fontFamily: "Arial",
    fontSize: ".13333px",
    letterSpacing: "0px",
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 3.4039314,
    y: 20.956221,
    fontSize: ".13333px"
  }, "Readerum.com"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.601 5.2361c-1.6224 1.7387-3.2448 3.4772-4.8672 5.2159h2.1655s-3.4471 3.6467-3.4471 3.6467 2.5633-6.83e-4 2.5633-6.83e-4 -3.7565 3.8891-3.7565 3.8891h5.5464s0.02209 3.8891 0.02209 3.8891 2.7842 4e-6 2.7842 4e-6l-0.06629-3.8891h5.0823l-3.9333-3.8891h2.9831l-3.8007-3.7123s2.3865-0.04419 2.3865-0.04419-4.3849-5.121-4.3849-5.121",
    fill: "none",
    stroke: "#000",
    strokeWidth: "1px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2.6639 8.4022c1.7525-2.1888 5.5623-5.297 9.5779-5.2965 4.0155 4.816e-4 6.6786 1.7889 9.5831 5.2965",
    fill: "none",
    stroke: "#000",
    strokeWidth: "1px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbientSound);
export default __webpack_public_path__ + "static/media/ambient-sound.c6c2211d506b93c387821e53f8a37cf1.svg";
export { ForwardRef as ReactComponent };